import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  api_request,
  setCommonReducer,
} from "../../store/actions/commonAction";
import {
  API_METHOD_GET,
  API_METHOD_POST,
  multiDocument,
} from "../../config/constants";
import {
  BILL_UPLOAD_ERROR,
  BILL_UPLOAD_SUCCESS,
} from "../../store/types/billTypes";
import { setBillReducer } from "../../store/actions/billActions";
import { useLocation, useNavigate } from "react-router";
import {
  FORBIDDEN_ACTION,
  GET_BASIC_ERROR,
  GET_BASIC_SUCCESS,
  UNAUTHORIZED_USER,
} from "../../store/types/authTypes";
import { theme } from "../../config/theme";
import Swal from "sweetalert2";
import CoreFileUploader from "../../core/inputs/CoreFileUploader";
import CoreModal from "../../core/layouts/CoreModal";
import CoreLinearProgress from "../../core/Loader/CoreLinearProgress";
import CoreContainedButton from "../../core/inputs/CoreContainedButton";
import { getApiHeader } from "../../helper/apiActionHelper";
import { backendUrl } from "../../config/api";

export default function InvoiceUpload() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const tool = location.pathname.split("/")[1];

  const [file, setFile] = useState(null);
  const [description, setDescription] = useState(null);
  const [uploadModal, setUploadModal] = useState(false);
  const [uploadPercentage, setUploadPercentage] = useState(0);
  const [tempData, setTempData] = useState(null);
  const [isMulti, setMulti] = useState(false);

  const auth = useSelector((state) => state?.auth);
  const billUploadSuccess = useSelector(
    (state) => state?.bill?.billUploadSuccess,
  );
  const billUploadError = useSelector((state) => state?.bill?.billUploadError);
  const billUploadMessage = useSelector(
    (state) => state?.bill?.billUploadMessage,
  );
  const billUploadData = useSelector((state) => state?.bill?.billUploadData);
  const submitBillSuccess = useSelector(
    (state) => state?.bill?.submitBillSuccess,
  );
  const submitBillError = useSelector((state) => state?.bill?.submitBillError);
  const submitBillMessage = useSelector(
    (state) => state?.bill?.submitBillMessage,
  );
  const docTypes = useSelector((state) => state.common.toolDocTypes);
  const appSettings = useSelector((state) => state?.common?.appSettings);
  const uploadMultiple = appSettings?.find((set) => set.name === multiDocument)
    ? appSettings?.find((set) => set.name === multiDocument)?.value?.enabled
    : false;

  useEffect(() => {
    if (file) {
      handlePdfUpload();
    }
  }, [file]);

  useEffect(() => {
    if (billUploadSuccess) {
      dispatch(
        api_request(
          API_METHOD_GET,
          "/business/individual/ProfileBasic",
          {},
          {
            _defaultFilter: encodeURIComponent(
              JSON.stringify({ userId: auth?.uid }),
            ),
          },
          null,
          GET_BASIC_SUCCESS,
          GET_BASIC_ERROR,
          true,
          false,
        ),
      );
      // alert(billUploadMessage);
      if (
        billUploadData?.docId ||
        tool === "tender-management" ||
        tool === "pricebook-management"
      ) {
        dispatch(
          setBillReducer({
            billUploadSuccess: false,
            docId: billUploadData.docId,
            docType: billUploadData.Type,
          }),
        );
        if (billUploadData.docId) {
          navigate("/" + tool + "/single");
        } else {
          navigate("/" + tool + "/unsaved/single");
        }
      } else {
        let uniqueId = billUploadData?.uniqueId;
        dispatch(
          setBillReducer({
            billUploadSuccess: false,
            billUploadData: null,
            jobBillsData: null,
          }),
        );
        Swal.fire({
          title: "Processing Started, ID:" + uniqueId,
          text: "You will be notified via email once done",
          icon: "success",
          confirmButtonColor: theme.palette.primary.main,
        });
        navigate("/" + tool + "/docs/view");
      }
    }
    if (billUploadError) {
      alert(billUploadMessage);
      dispatch(setBillReducer({ billUploadError: false }));
    }
  }, [billUploadSuccess, billUploadError]);

  useEffect(() => {
    if (submitBillSuccess) {
      alert(submitBillMessage);
      dispatch(setBillReducer({ submitBillSuccess: false }));
    }
    if (submitBillError) {
      alert(submitBillMessage);
      dispatch(setBillReducer({ submitBillError: false }));
    }
  }, [submitBillSuccess, submitBillError]);

  const onChangeDescription = (e) => {
    setDescription({
      descriptionId: e.target.id,
      [e.target.id]: e.target.value,
    });
  };

  const handlePdfUpload = (e) => {
    e?.preventDefault();

    let requestBody = {
      file: file,
      tool: tool,
      multipleDocument: file?.name?.toLowerCase()?.endsWith(".zip")
        ? false
        : isMulti,
    };
    console.log("file upload ", file, requestBody);
    if (file.size > 50 * 1024 * 1024) {
      if (tool === "tender-management") {
        alert("Zip not allowed for tender");
        return;
      }
      if (file.size > 5 * 1024 * 1024 * 1024) {
        alert("Maximum 5Gb file allowed");
        return;
      }
      setUploadModal(true);
      const chunkSize = 5 * 1024 * 1024; // 5MB (adjust based on your requirements)
      const totalChunks = Math.ceil(file.size / chunkSize);
      let chunkNumber = 0;
      let chunkDir = "";
      let start = 0;
      let end = start + chunkSize;

      const uploadNextChunk = async () => {
        console.log("Uploading next ", start, end, chunkNumber);

        // if (!uploadModal && chunkNumber > 1) {
        //   console.log("CANCELLING!!!!!!!");

        //   return;
        // }
        if (end <= file.size && start < end) {
          const chunk = file.slice(start, end);
          const formData = new FormData();
          formData.append("file", chunk);
          formData.append("chunkNumber", chunkNumber);
          formData.append("totalChunks", totalChunks);
          formData.append("originalname", file.name);
          formData.append("chunkDir", chunkDir);
          formData.append("tool", tool);
          if (chunkNumber + 1 === totalChunks) {
            dispatch(setCommonReducer({ loading: true }));
            dispatch(
              setBillReducer({
                billUploadLoading: true,
                billUploadSuccess: false,
                billUploadError: false,
                billUploadMessage: null,
                billUploadData: null,
              }),
            );
          }
          // let retry = 5;
          // while (retry > 0) {
          const headers = getApiHeader("POST", true, true);
          fetch(backendUrl + "/chunk/upload", {
            method: "POST",
            body: formData,
            headers: headers,
          })
            .then((response) => {
              if (response.status === 200) {
                response.json().then((data) => {
                  console.log(data, data?.data?.chunkDir);
                  if (chunkNumber === 0) {
                    chunkDir = data?.data?.chunkDir;
                  }
                  const percentage = Math.floor(
                    ((chunkNumber + 1) / totalChunks) * 100,
                  );
                  setUploadPercentage(percentage);
                  chunkNumber++;
                  start = end;
                  end = start + Math.min(chunkSize, file.size - end);
                  setTempData(data);
                  uploadNextChunk();
                });
              } else if (response.status === 401) {
                dispatch({ type: UNAUTHORIZED_USER });
              } else if (response.status === 403) {
                dispatch({ type: FORBIDDEN_ACTION });
              } else {
                console.error("Error uploading chunk:");
                setUploadPercentage(0);
                setUploadModal(false);
                setFile(null);
                dispatch(setCommonReducer({ loading: false }));
                setFile(null);
                alert("Internal error in file upload");
              }
            })
            .catch((error) => {
              console.error("Error uploading chunk:", error);
              dispatch(setCommonReducer({ loading: false }));
              setUploadPercentage(0);
              setUploadModal(false);
              setFile(null);
              alert("Internal error in file upload");
            });
          // }
        } else {
          dispatch(setCommonReducer({ loading: false }));
          setUploadPercentage(100);
          setUploadModal(false);
          dispatch(
            setBillReducer({
              billUploadLoading: false,
              billUploadSuccess: true,
              billUploadError: false,
              billUploadMessage: tempData?.message,
              billUploadData: tempData?.data,
            }),
          );
        }
      };

      uploadNextChunk();
    } else {
      dispatch(
        api_request(
          API_METHOD_POST,
          tool === "tender-management"
            ? "/tender/upload"
            : tool === "pricebook-management"
              ? "/pricebook/upload"
              : "/doc/upload",
          requestBody,
          {},
          null,
          BILL_UPLOAD_SUCCESS,
          BILL_UPLOAD_ERROR,
          true,
          true,
        ),
      );
    }
  };

  const handlePdfUploadMulti = (e) => {
    e.preventDefault();
    let requestBody = { file: file, type: "vendor" };
    if (description)
      requestBody["description"] = description[description["descriptionId"]];
    requestBody["multipleInvoice"] = true;
    dispatch(
      api_request(
        API_METHOD_POST,
        "/doc/upload",
        requestBody,
        {},
        null,
        BILL_UPLOAD_SUCCESS,
        BILL_UPLOAD_ERROR,
        true,
        true,
      ),
    );
  };

  console.log("billUploadData DATA", docTypes);
  return (
    <>
      <CoreModal
        open={uploadModal}
        handleClose={() => {}}
        title={"Uploading large file"}
      >
        <CoreLinearProgress value={uploadPercentage} />
        <Box
          style={{ display: "flex", justifyContent: "flex-end", marginTop: 16 }}
        >
          <CoreContainedButton
            color="error"
            onClick={() => {
              setUploadModal(false);
            }}
          >
            Cancel
          </CoreContainedButton>
        </Box>
      </CoreModal>
      <div
        style={{
          height: "calc(100vh - 68px - 4px)",
          width: "calc(100% + 32px)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginLeft: "-8px",
          marginTop: "-8px",
        }}
      >
        <CoreFileUploader
          tool={tool}
          handleChange={(file) => {
            if (file) {
              setFile(file);
            }
          }}
          isMulti={uploadMultiple}
          isMultiChecked={isMulti}
          onMultiChange={() => {
            setMulti(!isMulti);
          }}
        />
      </div>
    </>
  );
}
